import axios from 'axios';
import { API_BASE_URL } from '@/utils/environment';
import TopLoader from '@/utils/generalComponents/TopLoader';

let apiCounter = 0;

const api = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
});

api.interceptors.request.use((config) => {
  apiCounter += 1;
  const apiId = apiCounter;
  TopLoader.show(true, apiId);
  const headers = { ...config.headers };
  return { ...config, headers };
});

api.interceptors.response.use(
  (response) => {
    const apiId = apiCounter;
    TopLoader.hide(true, apiId);
    apiCounter -= 1;
    return response;
  },
  (error) => {
    const apiId = apiCounter;
    TopLoader.hide(true, apiId);
    apiCounter -= 1;
    return Promise.reject(error);
  },
);

export default api;
